import React from "react";

export function InputHiddenComponent({ data }) {
  return <input type="hidden" name={data.name} value={data.value} />;
}
